<template>
    <div v-if="oldFooterIsVisible" class="profile-footer">
        <div class="grid">
            <div class="profile-footer-content">
                <div class="social-links">
                    <a
                        v-for="(socialLink, index) in socialLinks"
                        :key="index"
                        :href="socialLink.url"
                        target="_blank"
                        rel="nofollow noopener"
                        :class="[showSocialIcons ? 'footer-icon' : 'footer-url', getCleanTypeOfSocialLink(socialLink.type.toLowerCase())]"
                    >
                        <i v-if="showSocialIcons" :class="`fa fa-${getCleanTypeOfSocialLink(socialLink.type.toLowerCase())}`"></i>
                        <template v-else>{{ getCleanTypeOfSocialLink(socialLink.type) }}</template>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "LegacyPageFooter",
    computed: {
        ...mapGetters("view", ["viewData"]),
        portfolio() {
            return this.viewData.portfolio;
        },
        templateSettings() {
            return this.portfolio.templateSettings;
        },
        oldFooterIsVisible() {
            return (
                !!this.portfolio
                && this.portfolio.settings
                && this.portfolio.settings.showFooterOnPortfolio === null
                && this.socialLinks.length > 0
                && this.templateSettings.theme !== 'profile_theme_four'
                && this.templateSettings.theme.indexOf('default') < 0
                && this.templateSettings.theme !== 'profile_theme_nine'
            ) && (
                this.templateSettings.theme === 'profile_theme_eight'
                || this.templateSettings.theme === 'theme_eight'
                || this.templateSettings.theme === 'theme_eleven'
                || this.templateSettings.theme === 'theme_twelve'
            );
        },
        showSocialIcons() {
            return this.templateSettings.theme === 'profile_theme_eight'
                || this.templateSettings.theme === 'theme_eight'
                || this.templateSettings.theme === 'theme_thirteen';
        },
        socialLinks() {
            return this.portfolio.socialLinks
                ? this.portfolio.socialLinks.filter((socialLink) => !!socialLink.url && !!socialLink.type)
                : [];
        }
    },
    methods: {
        getCleanTypeOfSocialLink(linkType) {
            if (linkType.toLowerCase() === "x-twitter") return "x";

            return linkType;
        }
    }
}
</script>
